import { motion } from 'framer-motion'
import { Star, Sparkles, Award, CheckCircle } from 'lucide-react'
import FeatureLayout from '../../components/FeatureLayout'
import { useLanguage } from '../../contexts/LanguageContext'

export default function AzrefyPointsPage() {
  const { t } = useLanguage()

  const levels = [
    { title: t('points.modal.level1.title'), desc: t('points.modal.level1.description'), points: '0' },
    { title: t('points.modal.level2.title'), desc: t('points.modal.level2.description'), points: '1,000' },
    { title: t('points.modal.level3.title'), desc: t('points.modal.level3.description'), points: '5,000' },
    { title: t('points.modal.level4.title'), desc: t('points.modal.level4.description'), points: '15,000' },
    { title: t('points.modal.level5.title'), desc: t('points.modal.level5.description'), points: '50,000' },
  ]

  return (
    <FeatureLayout
      title={t('points.modal.title')}
      subtitle={t('points.modal.subtitle')}
      gradientFrom="from-yellow-500"
      gradientTo="to-amber-500"
      icon={<Star className="h-10 w-10 text-white" />}
      featureName="AzrefyPoints"
    >
      {/* What Is Section */}
      <section className="mb-16">
        <div className="bg-gradient-to-r from-yellow-500/10 to-amber-500/10 rounded-3xl p-8 lg:p-12 border border-yellow-500/20">
          <div className="flex items-start gap-6">
            <div className="p-4 bg-yellow-500/20 rounded-2xl">
              <Sparkles className="h-8 w-8 text-yellow-400" />
            </div>
            <div>
              <h2 className="text-3xl font-bold text-white mb-4">{t('points.modal.whatIs')}</h2>
              <p className="text-gray-300 text-lg leading-relaxed">{t('points.modal.intro')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Tier Levels */}
      <section className="mb-16">
        <h2 className="text-3xl font-bold text-white mb-8">{t('points.modal.levels')}</h2>

        <div className="space-y-4">
         {levels.map((level, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="bg-gradient-to-r from-yellow-500/10 to-amber-500/10 rounded-2xl p-6 border border-yellow-500/20 flex items-center justify-between"
            >
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 bg-yellow-500/20 rounded-xl flex items-center justify-center">
                  <Award className="h-7 w-7 text-yellow-400" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white">{level.title}</h3>
                  <p className="text-gray-400 text-sm">{level.desc}</p>
                </div>
              </div>
              <div className="text-right">
                <div className="text-2xl font-bold text-yellow-400">{level.points}</div>
                <div className="text-sm text-gray-400">{t('points.modal.pointsLabel')}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section>
        <div className="bg-gradient-to-r from-yellow-600/20 to-amber-600/20 rounded-3xl p-8 lg:p-12 border border-yellow-500/30 text-center">
          <CheckCircle className="h-16 w-16 text-yellow-400 mx-auto mb-6" />
          <h2 className="text-3xl font-bold text-white mb-4">{t('points.modal.cta')}</h2>
          <p className="text-gray-300 text-lg mb-8 max-w-2xl mx-auto">
            {t('points.modal.ctaDescription')}
          </p>
          <a
            href="/#waitlist"
            className="inline-block px-8 py-4 bg-gradient-to-r from-yellow-500 to-amber-500 hover:from-yellow-600 hover:to-amber-600 text-white font-semibold rounded-xl transition-all transform hover:scale-105"
          >
            Join Waitlist Now
          </a>
        </div>
      </section>
    </FeatureLayout>
  )
}
